/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CashAccountTransaction from "./CashAccountTransaction";
import {
  deleteBanksCashAccounts,
  deleteBanksTransClients,
  downloadBankAccountexcel,
  getBankTransRecordList,
  uploadCashAccountTransList,
} from "../../../apis/finances/bank";
import DeleteIcon from "../../../assets/images/icon/delete-icon-01.svg";
import Button from "../../../components/Button";
import Modal, { ModalHeader } from "../../../components/Modal";
import { ControlTable } from "../../../components/Table";
import { isEmpty } from "lodash";
import { dateToViewFormat, formatDateHour } from "../../../utils/date";
import systemAlert from "../../../utils/systemAlert";
import { getParams } from "../../../utils/params";
import useForm from "../../../hooks/useForm";
import ClientMappingModal from "../../../components/Bank/ClientMappingModal";
import { preventEvent } from "../../../utils/element";
import { clientPreview } from "../../../utils/client";
import IconButton from "../../../components/Button/IconButton";
import BankDetail from "../AccountDetail/BankDetail";
import { deleteAccountingTitle } from "../../../apis/finances/accounting-title";
import CategoryMappingModal from "../../../components/Bank/CategoryMappingModal";
import { ModalBody } from "reactstrap";
import Row from "../../../components/ContentLayout/Row";
import Col from "../../../components/ContentLayout/Col";
import DataComponent from "../../../components/DataComponent";
import { downExcelFile } from "../../../utils/download";
import cashAccountSample from "../../../assets/file/cashAccountSample.xlsx";
import { isUndefined } from "lodash";
import { viewLoading } from "../../../utils/loading";


const CashAccount = ({ open, setOpen, params, bankData, setBankData, listSubmit, permission }) => {
  const [fields] = useState([
    {
      title: "거래일자",
      key: "tradeTime",
      onValue: (value) => {
        return dateToViewFormat(value, formatDateHour);
      },
    },
    {
      title: "입금액",
      key: "inAmt",
      type: "comma",
      className: "color-red-100",
    },
    {
      title: "출금액",
      key: "outAmt",
      type: "comma",
      className: "color-purple-100",
    },
    { title: "잔액", key: "balanceAmt", type: "comma" },
    { title: "적요", key: "remark" },
    {
      title: "거래처",
      key: "clients",
      className: "text-align-right",
      onValue: (value, field, data) => {
        return (
          !isEmpty(value) &&
          value.map((client, idx) => (
            <p className="pt-8 pb-8" key={idx}>
              <span className="vertical-middle"
                onClick={(e) => {
                  preventEvent(e);
                  client.companyAccount && clientPreview(client.companyAccount.idx);
                }}>{client.name}
              </span>
              {permission.level > 1 && (
                <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveClient(data, client)} />)}
            </p>
          ))
        );
      }
    },
    {
      title: '카테고리',
      key: 'accountingTitleUses',
      className: "text-align-right",
      onValue: (value) => {
        return (
          !isEmpty(value) &&
          value.map((category, idx) => (
            <p className="pt-8 pb-8" key={idx}>
              <span className="vertical-middle">{category.accountingTitle.name}</span>
              {permission.level > 1 && (
                <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveCategory(category)} />)}
            </p>
          ))
        );
      }
    }
    // { title: "거래처", key: "clients[0].companyAccount.name" },
  ]);
  const [isTransactionOpen, setIsTransactionOpen] = useState(false);
  const [bankTransData, setBankTransData] = useState({});
  // 거래처 매핑
  const [isClientMappingOpen, setIsClientMappingOpen] = useState(false);
  // 카테고리 매핑
  const [isCategoryMappingOpen, setIsCategoryMappingOpen] = useState(false);

  const [isExcelUploadModal, setIsExcelUploadModal] = useState(false);

  //상세내역
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailFormData, setDetailFromData] = useState({});
  const {
    form,
    setForm,
    setSubmit,
    handleSubmit,
    // LIST 용
    list,
    setList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    selectedList, setSelectedList,
    reSubmit
  } = useForm({
    bankAccountIdx: null,
    range: {
      transDate: [],
    },
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    setSubmit(submit);
  }, []);

  const handleRemoveClient = (data, client) => {
    const bankIdx = data.idx;
    const clientIdx = client.idx;

    systemAlert(`은행내역에 매핑된 거래처(${client.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteBanksTransClients(bankIdx, clientIdx)
              .then(() => {
                reSubmit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  const handleRemoveCategory = (category) => {
    systemAlert(`은행내역에 매핑된 카테고리(${category.accountingTitle.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteAccountingTitle(category.idx)
              .then(() => {
                reSubmit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  const submitParams = () => {
    const _params = {
      ...form,
      bankAccountIdx: bankData.idx,
      range: {
        tradeTime: [params.range.tradeTime[0], params.range.tradeTime[1]],
      },
    };

    setForm({
      bankAccountIdx: bankData.idx,
      range: {
        tradeTime: [params.range.tradeTime[0], params.range.tradeTime[1]],
      },
      ...(!isEmpty(params.checkingType) ? { checkingType: params.checkingType } : {})
    });

    return _params;
  };

  useEffect(() => {
    if (!isEmpty(bankData) && !isEmpty(params)) {
      submit(submitParams());
    }
  }, [bankData, params]);

  const submit = (params) => {
    setIsLoading(true);
    // params checkingType
    getBankTransRecordList(getParams(params))
      .then((res) => {
        setTotal(res.data.bankAccounts[0].transTotal);
        setList(res.data.bankAccounts[0].trans);
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const cancel = () => {
    setOpen(false);
    setBankData({});
  };

  const handleAddTransaction = () => {
    setIsTransactionOpen(true);
  };

  const rowBtnConfig = {
    title: '거래처 매핑 / 카테고리 매핑 / 내역 삭제',
    rowButtons: [
      {
        // 거래처 매핑
        type: "edit",
        className: "mr-4",
        action: (data) => {
          setIsClientMappingOpen(true);
          setSelectedList([data]);
        },
      },
      {
        // 카테고리 매핑
        type: "edit",
        className: "ml-4",
        action: (data) => {
          setIsCategoryMappingOpen(true);
          setSelectedList([data]);
        },
      },
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (data) => {
          if (!isEmpty(data.accountingTitleUses) || !isEmpty(data.clients)) {
            systemAlert("거래처 또는 카테고리 매핑이 되어있는 거래내역은 삭제할 수 없습니다.\n매핑내역 삭제 후 다시 시도해주세요.");
          } else {
            const idxList = [data.idx];
            systemAlert("해당 거래내역을 삭제하시겠습니까?", {
              buttons: [
                {
                  color: "text",
                  label: "취소",
                },
                {
                  label: "삭제",
                  onClick: () => {
                    deleteBanksCashAccounts(data.bankAccountNo, idxList).then(
                      () => {
                        submit(submitParams());
                      }
                    );
                  },
                },
              ],
            });
          }
        },
      },
    ],
  };

  const handleRowClick = (data, e) => {
    const { tagName } = e.target;
    if (tagName !== "TR" && tagName !== "TD") return;
    setIsTransactionOpen(true);
    setBankTransData(data);
  };


  const excelUploadButtons = [
    {
      // isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      color: "gray-line",
      size: "sm",
      type: 'button',
      label: (
        <>
          거래내역 업로드 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = cashAccountSample;
        a.style.display = "none";
        a.download = "cashAccountSample";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      // isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: `거래내역 엑셀 업로드`,
      color: "gray-line",
      size: "sm",
      key: "purchases_free",
      type: "excelfile",
      onChange: (e) => uploadExcelFile(e, bankData.accountNo),
    },
  ];

  const excelDownloadAction = () => {
    const idx = bankData.idx;

    const body = {
      type: params.type,
      idx,
      range: {
        tradeTime: {
          from: params.range.tradeTime[0],
          to: params.range.tradeTime[1]
        },
      },
    };

    downloadBankAccountexcel(body).then((res) => {
      downExcelFile(res,
        `${bankData.name}_거래내역(${params.range.tradeTime[0]}-${params.range.tradeTime[1]}).xlsx`
      );
    });
  };


  const uploadExcelFile = (e, accountNo) => {
    const file = e.target.files[0];

    if (!isUndefined(file)) {
      systemAlert(`"${file.name}" 파일을 업로드 하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소",
          },
          {
            label: "확인",
            onClick: () => {
              setIsExcelUploadModal(false);
              viewLoading("거래내역 등록중 입니다.");
              const formData = new FormData();
              formData.append("file", file);

              uploadCashAccountTransList(accountNo, formData)
                .then(() => {
                  systemAlert('거래내역이 등록되었습니다.');
                  reSubmit();
                })
                .finally(() => {
                  viewLoading(false);
                });

            },
          },
        ],
      });
    }

  };

  return (
    <>
      <Modal isOpen={open} close={cancel}>
        <div className="cash-account-datail-modal">
          <div className="modal-header-wrap">
            <ModalHeader>{bankData.name} 상세 내역</ModalHeader>
            {permission.level > 1 && (
              <>
                <div>
                  <Button
                    className="add-trans-button"
                    color="line"
                    label="거래내역 추가"
                    onClick={handleAddTransaction}
                  />
                </div>
                <div>
                  <Button
                    className="add-trans-button mr-10"
                    color="gray-line"
                    label={
                      <>
                        엑셀 업로드 <i className="mdi mdi-arrow-collapse-up" />
                      </>
                    }
                    onClick={() => { setIsExcelUploadModal(true); }}
                  />
                </div>
                {!isEmpty(list) && (
                  <div>
                    <Button
                      className="add-trans-button mr-10"
                      color="gray-line"
                      label={
                        <>
                          엑셀 다운로드 <i className="mdi mdi-arrow-collapse-down" />
                        </>
                      }
                      action={excelDownloadAction}
                    />
                  </div>
                )}
              </>
            )}
          </div>
          <ControlTable
            isLoading={isLoading}
            fields={fields}
            list={list}
            total={total}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            title={`${dateToViewFormat(
              params.range.tradeTime[0]
            )} ~ ${dateToViewFormat(params.range.tradeTime[1])} 거래내역`}
            rowBtn={permission.level > 1 ? rowBtnConfig : {}}
            submit={handleSubmit}
            onSelect={handleRowClick}
          />
          <div className="control-button-wrap">
            <Button className="close-button" label="닫기" onClick={cancel} />
          </div>
        </div>
      </Modal>
      <CashAccountTransaction
        open={isTransactionOpen}
        setOpen={setIsTransactionOpen}
        bankData={bankData}
        submit={() => submit(form)}
        listSubmit={listSubmit}
        formData={bankTransData}
        setFormData={setBankTransData}
        permission={permission}
      />

      <BankDetail
        permission={permission}
        open={detailOpen}
        setOpen={setDetailOpen}
        formData={detailFormData}
        setFormData={setDetailFromData}
        listSubmit={() => reSubmit(submitParams())}
        type={"cach"}
      />

      {isClientMappingOpen && !isEmpty(selectedList) && (
        <ClientMappingModal
          open={isClientMappingOpen}
          setOpen={setIsClientMappingOpen}
          selected={selectedList}
          setSelected={setSelectedList}
          submit={() => reSubmit(submitParams())}
        />
      )}


      {isCategoryMappingOpen && !isEmpty(selectedList) && (
        <CategoryMappingModal
          open={isCategoryMappingOpen}
          setOpen={setIsCategoryMappingOpen}
          selectedItem={selectedList}
          setSelectedItem={setSelectedList}
          useType="bank_trans"
          submit={() => reSubmit(submitParams())}
        />
      )}

      <Modal size="md" isOpen={isExcelUploadModal} close={() => setIsExcelUploadModal(false)}>
        <ModalHeader>엑셀 업로드</ModalHeader>
        <ModalBody>
          <Row>
            <Col style={{ textAlign: 'center', }}>
              <DataComponent field={{ ...excelUploadButtons[0] }} />
            </Col>
            <Col style={{ textAlign: 'center', }}>
              <DataComponent field={{ ...excelUploadButtons[1] }} />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CashAccount;
